import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheckCircle = () => {
  return (
    <g>
      <path d="m15.8877 7.3a.75.75 0 0 0 -1.4941.1328c.0166.1865.0244.376.0244.5669a6.4161 6.4161 0 1 1 -2.83-5.3228.75.75 0 0 0 .84-1.2432 7.9194 7.9194 0 1 0 3.49 6.5663q0-.3538-.0303-.7z" />
      <path d="m5.2451 6.4853a.75.75 0 0 0 -1.0605 1.0606l3.2854 3.2841a.75.75 0 0 0 1.0605 0l6.8005-6.8007a.75.75 0 0 0 -1.061-1.0606l-6.27 6.2706z" />
    </g>
  );
};

export default withIcon(IconCheckCircle);
